// extracted by mini-css-extract-plugin
export var navigationMenuLink = "styles-module__navigationMenuLink___iCtGm";
export var mobileLeftSpacer = "styles-module__mobileLeftSpacer___eKo1u";
export var navigationMenu = "styles-module__navigationMenu___Ima9q";